var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.adGroupName
          ? _vm.adGroupName + " - 配置Banner"
          : "配置Banner",
        visible: _vm.dialogVisible,
        width: "1200px",
        "before-close": _vm.handleClose,
        "custom-class": "ad-group-banner-dialog",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _vm.showWarning
            ? _c("div", { staticClass: "warning-tip" }, [
                _c("i", { staticClass: "el-icon-warning-outline" }),
                _c("span", [
                  _vm._v("启用后广告组将立即在乘客端展示,请关注banner状态"),
                ]),
              ])
            : _vm._e(),
          _vm.dialogVisible
            ? _c("BannerList", {
                ref: "bannerList",
                attrs: {
                  "hide-group-name-filter": true,
                  "extra-query-params": _vm.extraQueryParams,
                  "custom-table-config": _vm.customTableConfig,
                  showAddButton: true,
                  "use-cache": false,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.dialogMode === "config"
            ? [
                _c("el-button", { on: { click: _vm.handleCancel } }, [
                  _vm._v("返回广告组列表"),
                ]),
              ]
            : [
                _c("el-button", { on: { click: _vm.handleCancel } }, [
                  _vm._v("暂不启用"),
                ]),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleConfirm },
                  },
                  [_vm._v("确认启用")]
                ),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }